 
import {LANGUAGE_OPTIONS, CURRENCY_OPTIONS} from "../../constants/options"
import { t } from "../../i18n";

function getDefaultNavItems() {
  return [
    { key: "home", label: t("navHome"), path: "/" },
    {
      key: "products",
      label: t("navProducts"),
      path: "/products",
      children: [
        { key: "yoga-mats", label: t("navYogaMats"), path: "/products?group=Yoga%20Mats" },
        { key: "yoga-blocks", label: t("navYogaBlocks"), path: "/products?group=Yoga%20Blocks" },
        { key: "yoga-straps", label: t("navYogaStraps"), path: "/products?group=Yoga%20Straps" },
        { key: "resistance-bands", label: t("navResistanceBands"), path: "/products?group=Resistance%20Bands" },
        { key: "pilates-rings", label: t("navPilatesRings"), path: "/products?group=Pilates%20Rings" },
        { key: "foam-rollers", label: t("navFoamRollers"), path: "/products?group=Foam%20Rollers" }
      ]
    },
    { key: "customization", label: t("navOemPrivateLabel"), path: "/custom-service" },
    { key: "solutions", label: t("navSolutions"), path: "/#quality" },
    { key: "blog", label: t("navBlog"), path: "/blog" },
    { key: "about", label: t("navAbout"), path: "/about" },
    { key: "contact", label: t("navContactUs"), path: "/contact" }
  ];
}

function resolveLocalizedTopNavLabel(key, path, fallbackLabel) {
  const normalizedKey = String(key || "").trim().toLowerCase();
  const normalizedPath = String(path || "").trim().toLowerCase();

  if (normalizedKey === "home" || normalizedPath === "/") {
    return t("navHome");
  }

  if (normalizedKey === "products" || normalizedPath === "/products") {
    return t("navProducts");
  }

  if (
    normalizedKey === "customization" ||
    normalizedPath === "/oem-private-label" ||
    normalizedPath === "/#customization" ||
    normalizedPath === "/custom-service"
  ) {
    return t("navOemPrivateLabel");
  }

  if (normalizedKey === "solutions" || normalizedKey === "quality" || normalizedPath === "/solutions" || normalizedPath === "/#quality") {
    return t("navSolutions");
  }

  if (normalizedKey === "blog" || normalizedPath === "/blog" || normalizedPath === "/news") {
    return t("navBlog");
  }

  if (normalizedKey === "about" || normalizedPath === "/about") {
    return t("navAbout");
  }

  if (normalizedKey === "contact" || normalizedPath === "/contact") {
    return t("navContactUs");
  }

  return fallbackLabel;
}

function resolveLocalizedCategoryLabel(key, path, fallbackLabel) {
  const normalizedKey = String(key || "").trim().toLowerCase();
  const normalizedPath = String(path || "").trim().toLowerCase();

  if (normalizedKey === "yoga-mats" || /group=yoga%20mats/.test(normalizedPath)) {
    return t("navYogaMats");
  }
  if (normalizedKey === "yoga-blocks" || /group=yoga%20blocks/.test(normalizedPath)) {
    return t("navYogaBlocks");
  }
  if (normalizedKey === "yoga-straps" || /group=yoga%20straps/.test(normalizedPath)) {
    return t("navYogaStraps");
  }
  if (normalizedKey === "resistance-bands" || /group=resistance%20bands/.test(normalizedPath)) {
    return t("navResistanceBands");
  }
  if (normalizedKey === "pilates-rings" || /group=pilates%20rings/.test(normalizedPath)) {
    return t("navPilatesRings");
  }
  if (normalizedKey === "foam-rollers" || /group=foam%20rollers/.test(normalizedPath)) {
    return t("navFoamRollers");
  }

  return fallbackLabel;
}

function getBuyerSegments() {
  return [
    { label: t("buyerWholesalers"), iconImage: "/assets/feature-icons/supplier-review.svg", icon: "🏬", note: t("buyerWholesalersNote") },
    { label: t("buyerRetailers"), iconImage: "/assets/feature-icons/sourcing.svg", icon: "🛍️", note: t("buyerRetailersNote") },
    { label: t("buyerFitnessBrands"), iconImage: "/assets/feature-icons/private-label.svg", icon: "🏷️", note: t("buyerFitnessBrandsNote") },
    { label: t("buyerYogaStudios"), iconImage: "/assets/feature-icons/flexible-order.svg", icon: "🧘", note: t("buyerYogaStudiosNote") },
    { label: t("buyerAmazonSellers"), iconImage: "/assets/feature-icons/export.svg", icon: "📦", note: t("buyerAmazonSellersNote") },
    { label: t("buyerEcom"), iconImage: "/assets/feature-icons/docs.svg", icon: "💻", note: t("buyerEcomNote") }
  ];
}

function getServiceFeatures() {
  return [
    { iconImage: "/assets/feature-icons/sourcing.svg", title: t("featureSourcingTitle"), body: t("featureSourcingBody") },
    { iconImage: "/assets/feature-icons/private-label.svg", title: t("featurePrivateLabelTitle"), body: t("featurePrivateLabelBody") },
    { iconImage: "/assets/feature-icons/flexible-order.svg", title: t("featureFlexibleOrderTitle"), body: t("featureFlexibleOrderBody") },
    { iconImage: "/assets/feature-icons/export.svg", title: t("featureExportTitle"), body: t("featureExportBody") }
  ];
}

function getSupplyChainMetrics() {
  return [
    { iconImage: "/assets/feature-icons/verified.svg", value: t("metricVerified"), label: t("metricVerifiedLabel") },
    { iconImage: "/assets/feature-icons/moq.svg", value: t("metricMoq"), label: t("metricMoqLabel") },
    { iconImage: "/assets/feature-icons/branding.svg", value: t("metricBranding"), label: t("metricBrandingLabel") },
    { iconImage: "/assets/feature-icons/docs.svg", value: t("metricDocs"), label: t("metricDocsLabel") }
  ];
}

function getWhyChoosePoints() {
  return [
    { title: t("whyVerifiedTitle"), body: t("whyVerifiedBody"), icon: "✔" },
    { title: t("whyMoqTitle"), body: t("whyMoqBody"), icon: "◐" },
    { title: t("whyOemTitle"), body: t("whyOemBody"), icon: "◎" },
    { title: t("whySourcingTitle"), body: t("whySourcingBody"), icon: "◇" },
    { title: t("whyDeliveryTitle"), body: t("whyDeliveryBody"), icon: "↔" },
    { title: t("whyInspectionTitle"), body: t("whyInspectionBody"), icon: "▣" }
  ];
}

function getCompanyProofStats() {
  return [
    t("proofStatA"),
    t("proofStatB"),
    t("proofStatC")
  ];
}

function getQualityControlPoints() {
  return [
    {
      iconImage: "/assets/feature-icons/supplier-review.svg",
      previewImage: "/assets/feature-icons/supplier-review.svg",
      title: t("qcSupplierTitle"),
      body: t("qcSupplierBody")
    },
    {
      iconImage: "/assets/feature-icons/inspection.svg",
      previewImage: "/assets/feature-icons/inspection.svg",
      title: t("qcInspectionTitle"),
      body: t("qcInspectionBody")
    },
    {
      iconImage: "/assets/feature-icons/compliance.svg",
      previewImage: "/assets/feature-icons/compliance.svg",
      title: t("qcComplianceTitle"),
      body: t("qcComplianceBody")
    },
    {
      iconImage: "/assets/feature-icons/certification.svg",
      previewImage: "/assets/feature-icons/certification.svg",
      title: t("qcCertTitle"),
      body: t("qcCertBody")
    }
  ];
}

const NAV_ITEMS = getDefaultNavItems();
const BUYER_SEGMENTS = getBuyerSegments();
const SERVICE_FEATURES = getServiceFeatures();
const SUPPLY_CHAIN_METRICS = getSupplyChainMetrics();
const WHY_CHOOSE_POINTS = getWhyChoosePoints();
const COMPANY_PROOF_STATS = getCompanyProofStats();
const QUALITY_CONTROL_POINTS = getQualityControlPoints();

const CERTIFICATION_PLACEHOLDERS = ["CE", "RoHS", "REACH", "EN71", "CPSIA", "Prop 65"];

function getFaqItems() {
  return [
    { q: t("faqQ1"), a: t("faqA1") },
    { q: t("faqQ2"), a: t("faqA2") },
    { q: t("faqQ3"), a: t("faqA3") }
  ];
}

const FAQ_ITEMS = getFaqItems();

// All TEXTS keys are now i18n keys, use t(key) everywhere
// Example: t("title"), t("subtitle"), etc. See storefrontI18n.js for all keys.

function getHeaderPoints() {
  return [t("headerVerified"), t("headerPrivateLabel"), t("headerGlobalShipping")];
}

const HEADER_POINTS = getHeaderPoints();

function flattenNavItems(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .filter((item) => item.visible !== false)
    .flatMap((item) => [item, ...flattenNavItems(item.children)]);
}

function normalizeNavTree(items, depth = 1, parentKey = "menu") {
  if (!Array.isArray(items) || depth > 3) {
    return [];
  }

  return items
    .map((item, index) => {
      if (!item || typeof item !== "object") {
        return null;
      }

      const key = String(item.key || `${parentKey}-${index + 1}`).trim();
      const label = String(item.label || "").trim();
      const path = String(item.path || "").trim();
      if (!key || !label || !path) {
        return null;
      }

      const pathLower = path.toLowerCase();
      const isCustomizationEntry =
        key.toLowerCase() === "customization" ||
        pathLower === "/oem-private-label" ||
        pathLower === "/#customization";
      const resolvedPath = isCustomizationEntry ? "/custom-service" : path;
      const topLocalizedLabel = resolveLocalizedTopNavLabel(key, resolvedPath, label);
      const categoryLocalizedLabel = resolveLocalizedCategoryLabel(key, resolvedPath, topLocalizedLabel);
      const keyLikeLocalizedLabel = /^nav[A-Z]/.test(label) ? t(label) : categoryLocalizedLabel;
      const normalized = {
        key,
        label: keyLikeLocalizedLabel,
        path: resolvedPath
      };
      normalized.visible = item.visible !== false;
      if (depth < 3) {
        const children = normalizeNavTree(item.children, depth + 1, `${key}-child`);
        if (children.length) {
          normalized.children = children;
        }
      }

      return normalized;
    })
    .filter(Boolean);
}

function collectNavNodes(items, parentIndex = "") {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .filter((item) => item.visible !== false)
    .flatMap((item, index) => {
      const indexPath = parentIndex ? `${parentIndex}-${index}` : String(index);
      return [{ item, index: indexPath }, ...collectNavNodes(item.children, indexPath)];
    });
}

function matchesNavPath(currentLocation, path) {
  if (!path) {
    return false;
  }

  const rawPath = String(path).trim();
  const [pathAndQuery, hashSegment = ""] = rawPath.split("#");
  const cleanPath = pathAndQuery || "/";
  const targetHash = hashSegment ? `#${hashSegment}` : "";
  const currentPath = `${currentLocation.pathname}${currentLocation.search || ""}`;
  const currentPathname = currentLocation.pathname;
  const currentHash = currentLocation.hash || "";

  if (cleanPath.includes("?")) {
    return currentPath === cleanPath && (!targetHash || currentHash === targetHash);
  }

  if (cleanPath === "/") {
    if (targetHash) {
      return currentPathname === "/" && currentHash === targetHash;
    }

    return currentPathname === "/" && !currentHash && !currentLocation.search;
  }

  const pathMatched = currentPathname === cleanPath || currentPathname.startsWith(`${cleanPath}/`);
  if (!pathMatched) {
    return false;
  }

  if (targetHash) {
    return currentHash === targetHash;
  }

  return true;
}

function getNavItemId(item, fallbackIndex = "0") {
  return String(item?.key || `${item?.label || t("nav")}-${item?.path || ""}-${fallbackIndex}`);
}

function formatBreadcrumbLabel(segment) {
  if (!segment) {
    return "";
  }

  if (/^\d+$/.test(segment)) {
    return t("breadcrumbProductDetail");
  }

  return segment.replace(/-/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function getBreadcrumbItems(pathname, navItems, homeLabel = t("breadcrumbHomeSeries")) {
  const items = [{ label: t("breadcrumbHome"), path: "/" }];
  const segments = pathname.split("/").filter(Boolean);
  const flatNavItems = flattenNavItems(navItems);

  if (!segments.length) {
    items.push({ label: homeLabel });
    return items;
  }

  const matchedNavItem = flatNavItems.find((item) => {
    if (item.path === "/") {
      return pathname === "/";
    }

    return pathname === item.path || pathname.startsWith(`${item.path}/`);
  });

  if (matchedNavItem && matchedNavItem.path !== "/") {
    items.push({ label: matchedNavItem.label, path: matchedNavItem.path });
  }

  if (segments.length > 1) {
    const detailLabel = formatBreadcrumbLabel(segments[segments.length - 1]);
    if (!items.some((item) => item.label === detailLabel)) {
      items.push({ label: detailLabel });
    }
  }

  return items;
}

export {
  LANGUAGE_OPTIONS,
  CURRENCY_OPTIONS,
  getDefaultNavItems,
  getBuyerSegments,
  getServiceFeatures,
  getSupplyChainMetrics,
  getWhyChoosePoints,
  getCompanyProofStats,
  getQualityControlPoints,
  getFaqItems,
  getHeaderPoints,
  NAV_ITEMS,
  BUYER_SEGMENTS,
  SERVICE_FEATURES,
  SUPPLY_CHAIN_METRICS,
  WHY_CHOOSE_POINTS,
  COMPANY_PROOF_STATS,
  QUALITY_CONTROL_POINTS,
  CERTIFICATION_PLACEHOLDERS,
  FAQ_ITEMS,
  HEADER_POINTS,
  flattenNavItems,
  normalizeNavTree,
  collectNavNodes,
  matchesNavPath,
  getNavItemId,
  formatBreadcrumbLabel,
  getBreadcrumbItems
};
